import React from "react";
import { UncontrolledTooltip } from "reactstrap";
import { getFormattedDateString, hasPermission } from "utility/helpers";
import {
  StyledEditIcon,
  StyledTrashIcon,
  StyledEyeIcon,
  CellText,
} from "assets/js/Styles";

const committeeColumns = ({
  handleDeleteAction,
  handleEditAction,
  handleViewAction,
}) => {
  return [
    {
      name: "",
      selector: null,
      sortable: false,
      id: "highlight",
      width: "5px",
      cell: () => null,
    },
    {
      name: "HOUSE MEMBER",
      selector: (row) => row?.congressman?.fullName,
      identifier: "congressman",
      grow: 2,
      sortable: true,
      minWidth: "300px",
      cell: (record) => (
        <CellText>
          {(record.congressman?.fullName || "").toUpperCase()}
        </CellText>
      ),
    },
    {
      name: "REGION",
      selector: (row) => row?.congressman?.district?.region?.name,
      identifier: "region",
      grow: 2,
      sortable: true,
      minWidth: "120px",
      cell: (record) => (
        <CellText>{record.congressman?.district?.region?.name || ""}</CellText>
      ),
    },
    {
      name: "DISTRICT/PARTYLIST",
      selector: (row) =>
        row?.congressman?.district?.name ||
        row?.congressman?.district?.region?.name,
      identifier: "district",
      grow: 2,
      sortable: true,
      minWidth: "150px",
      cell: (record) => {
        let columnValue = "";

        if (record.congressman?.district?.province) {
          columnValue = record.congressman?.district?.name;
        } else {
          columnValue = record.congressman?.district?.region?.name;
        }

        return <CellText>{columnValue || ""}</CellText>;
      },
    },
    {
      name: "AFFILIATION",
      selector: (row) => row?.congressman?.party?.acronym,
      identifier: "party",
      grow: 1,
      sortable: true,
      minWidth: "50px",
      cell: (record) => (
        <CellText>{record.congressman?.party?.acronym || ""}</CellText>
      ),
    },
    {
      name: "COMMITTEE",
      selector: (row) => row?.committee?.name,
      identifier: "committee",
      grow: 2,
      sortable: true,
      minWidth: "150px",
      cell: ({ committee }) => <CellText>{committee?.name || ""}</CellText>,
    },
    {
      name: "POSITION",
      selector: (row) => row?.position?.name || row?.position,
      identifier: "position",
      grow: 2,
      sortable: true,
      minWidth: "120px",
      cell: ({ position }) => (
        <CellText>{position?.name || position || ""}</CellText>
      ),
    },
    {
      name: "DATE ELECTED",
      selector: (row) => row?.dateElected,
      identifier: "dateElected",
      sortable: true,
      minWidth: "150px",
      cell: ({ dateElected }) => (
        <CellText>
          {dateElected
            ? getFormattedDateString(dateElected, "MMM dd, yyyy")
            : "-"}
        </CellText>
      ),
    },
    {
      name: "SOURCE",
      selector: (row) => row?.source,
      identifier: "source",
      grow: 2,
      sortable: true,
      minWidth: "150px",
      cell: ({ source }) => <CellText>{source || "-"}</CellText>,
    },
    {
      name: "DATE MODIFIED",
      selector: (row) => row?.dateModified || row?.updatedAt,
      identifier: "createdAt",
      sortable: true,
      minWidth: "100px",
      cell: ({ dateModified, updatedAt }) => {
        const date = dateModified || updatedAt;

        return (
          <CellText>
            {date ? getFormattedDateString(date, "MMM dd, yyyy") : "-"}
          </CellText>
        );
      },
    },
    {
      name: "ACTIONS",
      selector: (row) => row?.id,
      sortable: false,
      width: "150px",
      style: { cursor: "pointer" },
      center: true,
      id: "action",
      cell: (row, index) => (
        <>
          {hasPermission("membership-committee-update") && (
            <>
              <StyledEditIcon
                size={16}
                id={`edit-row--${row.id || index}`}
                onClick={() => handleEditAction && handleEditAction(row)}
              />
              <UncontrolledTooltip
                placement="auto"
                target={`edit-row--${row.id || index}`}
              >
                {"Edit"}
              </UncontrolledTooltip>
            </>
          )}

          {hasPermission("membership-committee-view") && (
            <>
              <StyledEyeIcon
                size={16}
                id={`view-row--${row.id || index}`}
                onClick={() => handleViewAction && handleViewAction(row)}
              />
              <UncontrolledTooltip
                placement="auto"
                target={`view-row--${row.id || index}`}
              >
                {"View"}
              </UncontrolledTooltip>
            </>
          )}

          {hasPermission("membership-committee-delete") &&
            handleDeleteAction && (
              <>
                <StyledTrashIcon
                  size={16}
                  id={`delete-row--${row.id || index}`}
                  onClick={() => handleDeleteAction(row)}
                />
                <UncontrolledTooltip
                  placement="right"
                  target={`delete-row--${row.id || index}`}
                >
                  {"Delete"}
                </UncontrolledTooltip>
              </>
            )}
        </>
      ),
    },
  ];
};

export default committeeColumns;
